module.exports = __webpack_public_path__ + "0f36010261d01c774043c47aa46a2010.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_6_b.png
// module id = 171
// module chunks = 0